import React from "react";
import { reduxStore } from "../../Redux/redux-store";
import { cacheService, eventsNotifier } from "../../Core/Api/services";
import { EventNotifierOperation } from "../../Core/Api/notifier-client";
import { IncrementUpdate, SetFetchedObject } from "../../Redux/Reducers/redux-slice-asset";
import { GetGraphResponse } from "../../Core/Api/Types/get-graph-response";
import { PlatformMode } from "../../Core/Api/Types/platform-mode";

const useAssetObjectUpdater = (objectId: number) => {
  const mode = cacheService.GetPlatformMode();

  React.useEffect(() => {
    if (mode === PlatformMode.Adam) {
      eventsNotifier.Connect().then(function (result) {
        console.debug("Hub Events Connected successfully to WebSocket and is listening to AssetMessage!");
        if (eventsNotifier.connection)
          eventsNotifier.connection.on("AssetMessage", (data) => {
            switch (data.op) {
              case EventNotifierOperation.Update:
                if (objectId !== data.data.id) return;

                let resp: GetGraphResponse = {
                  layer: null,
                  graph: data.data,
                  views: null,
                  hierarchy: null,
                  success: true,
                  rescode: 0,
                  message: null,
                  objectId: objectId,
                };

                reduxStore.dispatch(SetFetchedObject(resp));
                reduxStore.dispatch(IncrementUpdate());

                console.debug(`Asset updated with websocket for id = ${objectId}`);
                break;
            }
          });
      });

      // Disconnect when unmount
      return function cleanup() {
        eventsNotifier.Disconnect().then(function () {
          console.debug(`Asset updater closed!`);
        });
      };
    }
  }, [objectId]);
};

export default useAssetObjectUpdater;
